import * as Slider from '@radix-ui/react-slider';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

type FormSliderFieldProps = {
  id: string;
  label: string;
  description?: string;
  value: number;
  onChange: (value: number) => void;
  rangeMin: number;
  rangeMax: number;
  step: number;
  formatValue?: (value: number) => string;
  disabled?: boolean;
};

export function FormSliderField({
  id,
  label,
  description,
  value,
  onChange,
  rangeMin,
  rangeMax,
  step,
  formatValue = (v) => `${v}s`,
  disabled,
}: FormSliderFieldProps) {
  return (
    <div className={cn("grid gap-1.5", disabled && "opacity-50")}>
      <Label htmlFor={id} className="font-medium text-gray-900">
        {label}
      </Label>
      {description && (
        <p className="text-detail text-gray-500 leading-tight">{description}</p>
      )}
      <div className="pt-1 pb-2">
        <Slider.Root
          id={id}
          value={[value]}
          min={rangeMin}
          max={rangeMax}
          step={step}
          onValueChange={([v]) => onChange(v)}
          disabled={disabled}
          className="relative flex h-5 w-full touch-none select-none items-center"
        >
          <Slider.Track className="relative h-1.5 w-full grow rounded-full bg-gray-200">
            <Slider.Range className="absolute h-full rounded-full bg-gray-900" />
          </Slider.Track>
          <Slider.Thumb
            className="block size-4 rounded-full bg-white border-2 border-gray-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1"
            aria-label={label}
          />
        </Slider.Root>
        <div className="flex justify-between mt-1">
          <span className="text-detail text-gray-400">{formatValue(rangeMin)}</span>
          <span className="text-detail text-gray-700 font-medium">{formatValue(value)}</span>
          <span className="text-detail text-gray-400">{formatValue(rangeMax)}</span>
        </div>
      </div>
    </div>
  );
}
